import styled from "styled-components";
import Section from "../components/Section";

const ChatWrapper = styled.div `
  #aichatbot-widget-window {
    display: flex !important;
    position: relative;
    top: -3em;
    width: 100%;
    height: auto;
    max-height: 75vh;

    @media (min-width: 600px) {
      top: 0px;
      max-width: 830px;
      width: 95vw;
      height: 75vh;
    }
  }

  #aichatbot-widget-window > div:first-child {
    width: 100vw;
    height: auto;
    min-height: 75vh;
  }

  #aichatbot-widget-close-icon {
    display: none;
  }
  #ai-chat-frame {
    width: 100%;
    max-width: 830px;
    height: 75vh;
    border: none;

  }
`;

const ChatBot = () => {

  return (
    <Section>
      <ChatWrapper>
        <iframe
          title="Chat AI Widget"
          id="ai-chat-frame"
          src="https://emb-chat.noform.ai/?pid=6973dab657caa23c6ab79b73&backendURL=https://app.noform.ai"
        />
      </ChatWrapper>
    </Section>
  );
};
export default ChatBot;